import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { OnlineStatusContext } from '../../context/OnlineStatusContext';
import { timeAgo } from '../../utils/helpers';
import { isMemberOnline } from '../../utils/onlineStatus';

/**
 * LastActive component displays user's last active status.
 * "Online now" / "Last active …" decisions use the shared isMemberOnline()
 * rule so the text and the presence dot can never disagree.
 */
const LastActive = ({ member, className = '', showOnlineStatus = true }) => {
  const onlineUsers = useContext(OnlineStatusContext) || {};
  const currentUserId = useSelector((state) => state.user?.user?._id);

  if (!member) return null;

  const isOnline = isMemberOnline(member, onlineUsers, currentUserId);

  if (showOnlineStatus && isOnline) {
    return (
      <span className={`last-active online-now ${className}`}>
        Online now
      </span>
    );
  }

  if (!member.lastActive) {
    return (
      <span className={`last-active no-activity ${className}`}>
        No recent activity
      </span>
    );
  }

  const lastActiveText = timeAgo(member.lastActive);

  return (
    <span className={`last-active ${className}`}>
      Last active {lastActiveText}
    </span>
  );
};

export default LastActive;
